import { render, staticRenderFns } from "./VTable.vue?vue&type=template&id=f1e6134a&scoped=true&"
import script from "./VTable.vue?vue&type=script&lang=js&"
export * from "./VTable.vue?vue&type=script&lang=js&"
import style0 from "./VTable.vue?vue&type=style&index=0&id=f1e6134a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1e6134a",
  null
  
)

export default component.exports